// src/toolsData.js
const toolsData = [
  {
    icon: "fa fa-copy",
    title: "Merge PDF",
    description:
      "Combine PDFs in the order you want with the easiest PDF merger available.",
    link: "/MergePDF",
  },
  {
    icon: "fa fa-clone",
    title: "Split PDF",
    description:
      "Separate one page or a whole set for easy conversion into independent PDF files.",
    link: "/SplitPDF",
  },
  {
    icon: "fa fa-file-archive-o",
    title: "Compress PDF",
    description: "Reduce file size while optimizing for maximal PDF quality.",
    link: "/CompressPDF",
  },
  {
    icon: "fa fa-file-word-o",
    title: "PDF to Word",
    description:
      "Easily convert your PDF files into easy to edit DOC and DOCX documents.",
    link: "/PDFtoWORD",
  },
  {
    icon: "fa fa-file-powerpoint-o",
    title: "PDF to PowerPoint",
    description:
      "Turn your PDF files into easy to edit PPT and PPTX slideshows.",
    link: "/PDFtoPOWERPOINT",
  },
  {
    icon: "fa fa-file-excel-o",
    title: "PDF to Excel",
    description:
      "Accurately convert PDF tables into editable Excel spreadsheets.",
    link: "/PDFtoEXCEL",
  },
  {
    icon: "fa fa-file-pdf-o",
    title: "Word to PDF",
    description:
      "Make DOC and DOCX files easy to read by converting them to PDF.",
    link: "/WORDtoPDF",
  },
  {
    icon: "fa fa-file-powerpoint-o",
    title: "PowerPoint to PDF",
    description:
      "Make PPT and PPTX slideshows easy to view by converting them to PDF.",
    link: "/POWERPOINTtoPDF",
  },
  {
    icon: "fa fa-file-excel-o",
    title: "Excel to PDF",
    description:
      "Make XLS and XLSX files easy to read by converting them to PDF.",
    link: "/EXCELtoPDF",
  },
  //{
  //  icon: "fa fa-pencil",
  //  title: "Edit PDF",
  //  description:
  //    "Add text, images, shapes or freehand annotations to a PDF document.",
  //  link: "/PDFEditor",
  //},
  {
    icon: "fa fa-file-pdf-o",
    title: "PDF to JPG",
    description: "Extract images from your PDF or save each page as a JPG.",
    link: "/PDFtoJPG",
  },
  {
    icon: "fa fa-photo",
    title: "JPG to PDF",
    description: "Convert your images to PDF for better sharing or saving.",
    link: "/JPGtoPDF",
  },
  {
    icon: "fa fa-pencil-square-o",
    title: "Sign PDF",
    description: "Sign yourself or request electronic signatures from others.",
    link: "/SignPDF",
  },
  {
    icon: "fa fa-legal",
    title: "Watermark",
    description: "Stamp an image or text over your PDF in seconds.",
    link: "/AddwatermarkintoaPDF",
  },
  {
    icon: "fa fa-rotate-right",
    title: "Rotate PDF",
    description: "Rotate your PDFs the way you need them.",
    link: "/RotatePDF",
  },
  {
    icon: "fa fa-file-code-o",
    title: "HTML to PDF",
    description:
      "Convert webpages in HTML to PDF. Copy and Paste the URL of the page you want and convert it to PDF with a click.",
    link: "/HTMLtoPDF",
  },
  {
    icon: "fa fa-unlock-alt",
    title: "Unlock PDF",
    description: "Remove password protection from PDF files.",
    link: "/UnlockPDF",
  },
  {
    icon: "fa fa-lock",
    title: "Protect PDF",
    description: "Protect PDF files with a password.",
    link: "/ProtectPDF",
  },
  {
    icon: "fa fa-reorder",
    title: "Organize PDF",
    description:
      "Sort pages of your PDF file however you like. Delete PDF pages or add PDF pages to your document at your convenience.",
    link: "/OrganizePDF",
  },
  {
    icon: "fa fa-file-pdf-o",
    title: "PDF to PDF/A",
    description:
      "Transform your PDF to PDF/A, the ISO-standardized version of PDF for long-term archiving. Your PDF will preserve formatting when accessed in the future.",
    link: "/PDFtoPDFA",
  },
  {
    icon: "fa fa-magic",
    title: "Repair PDF",
    description:
      "Repair a damaged PDF and recover data from corrupt PDF. Fix PDF files with our Repair tool.",
    link: "/RepairPDFfile",
  },
  {
    icon: "fa fa-sort-numeric-asc",
    title: "Page Numbers",
    description:
      "Add page numbers into PDFs with ease. Choose your positions, dimensions, typography.",
    link: "/AddPDFpagenumbers",
  },
  {
    icon: "fa fa-camera",
    title: "Scan to PDF",
    description:
      "Capture document scans from your mobile device and send them instantly to your browser.",
    link: "/ScantoPDF",
  },
  {
    icon: "fa fa-print",
    title: "OCR PDF",
    description:
      "Easily convert scanned PDF into searchable and selectable documents.",
    link: "/OCRPDF",
  },
  {
    icon: "fa fa-clone",
    title: "Compare PDF",
    description:
      "Show a side-by-side document comparison and easily spot changes between different file versions.",
    link: "/ComparePDF",
  },
];

export default toolsData;
